<template lang="pug">
  main
    NavBarChecklist
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-full.has-text-centered
            h3.title Historia Válvula {{ idValvula }}
              |  
              router-link.a.button.is-default.is-rounded.is-medium(to="/Checklist")
                i.fas.fa-times
        .columns(v-show="hayDatos")
          .column.is-full
            .table-responsive
              table.table.table-sm.is-fullwidth.is-hoverable.is-fullwidth
                thead
                  tr
                    th.th-description Fecha Reg.
                    th Usuario
                    th.tooltip(:data-tooltip="getNombreTooltip('1')") 1
                    th.tooltip(:data-tooltip="getNombreTooltip('2')") 2
                    th.tooltip(:data-tooltip="getNombreTooltip('3')") 3
                    th.tooltip(:data-tooltip="getNombreTooltip('4')") 4
                    th.tooltip(:data-tooltip="getNombreTooltip('5')") 5
                    th.tooltip(:data-tooltip="getNombreTooltip('7')") 7
                    th.tooltip(:data-tooltip="getNombreTooltip('8')") 8
                    th.tooltip(:data-tooltip="getNombreTooltip('9')") 9
                    th.tooltip(:data-tooltip="getNombreTooltip('10')") 10
                    th.tooltip(:data-tooltip="getNombreTooltip('11')") 11
                    th.tooltip(:data-tooltip="getNombreTooltip('12')") 12
                    th.tooltip(:data-tooltip="getNombreTooltip('13')") 13
                    th.tooltip(:data-tooltip="getNombreTooltip('14')") 14
                    th.tooltip(:data-tooltip="getNombreTooltip('15')") 15
                    th.tooltip(:data-tooltip="getNombreTooltip('16')") 16
                    th.tooltip(v-show="is27" :data-tooltip="getNombreTooltip('17')") 17
                    th.tooltip(v-show="is27" :data-tooltip="getNombreTooltip('18')") 18
                tbody
                  tr(v-for="reg in registros" :key="reg.id")
                    td 
                      b {{ reg.fechaReg }}
                    td.td-name
                      b {{ reg.usuario }}
                    td(:id="reg.id + '_item1'")
                      span.icon.is-medium(v-if="reg.item1 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item2'")
                      span.icon.is-medium(v-if="reg.item2 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item3'")
                      span.icon.is-medium(v-if="reg.item3_a === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item3_b === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item4'")
                      span.icon.is-medium(v-if="reg.item4_a === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item4_b === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item4_c === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item4_d === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else-if="reg.item4_d === '1'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item5'")
                      span.icon.is-medium(v-if="reg.item5_a === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item5_b === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item5_c === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item5_d === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item5_e === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else-if="reg.item5_e === '1'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item7'")
                      span.icon.is-medium(v-if="reg.item7_a === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item7_b === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item8'")
                      span.icon.is-medium(v-if="reg.item8 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item9'")
                      span.icon.is-medium(v-if="reg.item9 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item10'")
                      span.icon.is-medium(v-if="reg.item10 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item11'")
                      span.icon.is-medium(v-if="reg.item11 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item12'")
                      span.icon.is-medium(v-if="reg.item12 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item13'")
                      span.icon.is-medium(v-if="reg.item13 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item14'")
                      span.icon.is-medium(v-if="reg.item14 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item15'")
                      span.icon.is-medium(v-if="reg.item15 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item16'")
                      span.icon.is-medium(v-if="reg.item16_a === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else)
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item16_b === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else-if="reg.item16_b === '1'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item17'" v-show="reg.item17_a !== '3'")
                      span.icon.is-medium(v-if="reg.item17_a === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else-if="reg.item17_a === '1'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-if="reg.item17_b === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else-if="reg.item17_b === '1'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
                    td(:id="reg.id + '_item18'" v-show="reg.item18 !== '3'")
                      span.icon.is-medium(v-if="reg.item18 === '0'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-danger
                          i.fas.fa-arrow-down.fa-stack-1x.has-text-white
                      span.icon.is-medium(v-else-if="reg.item18 === '1'")
                        span.fa-stack
                          i.fas.fa-circle.fa-stack-2x.has-text-success
                          i.fas.fa-check.fa-stack-1x.has-text-white
        .columns(v-show="!hayDatos")
          .column.is-offset-one-third.is-one-third
            .notification.is-warning
              button.delete
              |   No hay registros aún.
      .columns.column-blanco
</template>


<script>
  import NavBarChecklist from '@/components/checklist_Componentes/layout/NavBarChecklist.vue'
  import Loader from '@/components/shared/Loader.vue'
  import { mapState } from 'vuex'
  import ductosServices from '@/services/ducto'
  import moment from 'moment'

  export default {
    name: 'Historia',
    components: { NavBarChecklist, Loader },
    data() {
      return {
        idValvula: '',
        isLoading: true,
        registros: [],
        hayDatos: false,
        tipoPlano: '',
        items_names: [],
        is27: false
      }
    },
    methods: {
      iniciarComponente() {
        switch (this.idValvula) {
          case 'VS-03':
            this.tipoPlano = '1'  
            this.is27 = true
            break
          case 'VS-12':
            this.tipoPlano = '1'  
            this.is27 = true
            break
          case 'VS-19':
            this.tipoPlano = '1'  
            this.is27 = true
            break
          case 'VS-22':
            this.tipoPlano = '1'  
            this.is27 = true
            break
          default:
            this.tipoPlano = '2' 
            this.is27 = false
            break
        }
        this.obtenerItems()
        
      },
      obtenerItems () {
        ductosServices.getCheckList_Items(this.tipoPlano)
          .then( res => {
            this.items_names = res
            this.obtenerData()
          })
      }, 
      obtenerData () {
        setTimeout(() => {
          ductosServices.getCheckList_valores(this.idValvula)
            .then( res => {
              this.registros = res
              if (this.registros.length > 0) {
                this.hayDatos = true
              } else {
                this.hayDatos = false
              }
            })
          this.isLoading = false
        }, 500)
      },
      getNombreTooltip (num) {
        let numInt = parseInt(num)
        console.log(numInt)

        if (this.is27) {
          // obtener Todos los nombres
          console.log('obtener Todos los nombres')
          let itemName = this.items_names.find(i => i.num === num )
          console.log(itemName.num)
          return itemName.descripcion
        } else {
          if (numInt < 17) {
            console.log('is27 false - obtener menores a 17')
            let itemName = this.items_names.find(i => i.num === num )
            console.log(itemName.num)
            return itemName.descripcion
          } else {
            console.log('is27 false - mayores a 18')
            return ''
          }
        }
      }

    },
    created () {
      this.idValvula = this.$route.params.id
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    max-width: 1550px;
  }

  .table-responsive {
    overflow-x: auto;
  }

  .fa-stack { 
    font-size: 0.65em; 
  }
  i { 
    vertical-align: middle; 
  }

.columns.column-blanco {
  padding-bottom: 100px;
}
  
</style>


// WEBPACK FOOTER //
// src/components/checklist_Componentes/Historia.vue